import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { createAction, props } from "@ngrx/store";

import { ArchitectUIState } from "./index";

export const selectPlan = createAction(
  "[PaymentPlans] Select Plan",
  props<{ plan: any }>()
);
@Injectable({
  providedIn: "root", // recommended for Angular services
})
export class PaymentPlansActions {
  static SELECT_PLAN = "SELECT_PLAN";

  constructor(private store: Store<ArchitectUIState>) {}

  selectPlan(plan: any) {
    this.store.dispatch(selectPlan({ plan }));
  }
}
